// extracted by mini-css-extract-plugin
module.exports = {"threeSteps":"ThreeSteps_threeSteps__sXtJM","threeSteps__list":"ThreeSteps_threeSteps__list__p2px_","threeSteps__icon":"ThreeSteps_threeSteps__icon__qNa_4"};